import {
  Component,
  OnInit,
  Input,
  ViewChild,
  OnDestroy,
  Output,
  EventEmitter
} from '@angular/core'
import { FormGroup } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { CpmService } from '../../service/cpm.service'
import { StoreService } from '../../service/store.service'
import { Subscription } from 'rxjs/Subscription'
import { DataTableDirective } from 'angular-datatables'
import { Subject } from 'rxjs/Subject'
import { BsModalService } from 'ngx-bootstrap/modal'

@Component({
  selector: 'app-staff-contact',
  templateUrl: './staff-contact.component.html',
  styleUrls: ['./staff-contact.component.scss']
})
export class StaffContactComponent implements OnInit, OnDestroy {
  @ViewChild(DataTableDirective) dtElement: DataTableDirective
  @Input() companyProfile: any
  @Input() printPage
  @Input() exportFunctions: Map<String, Function>
  @Output() emitEditCase: EventEmitter<any> = new EventEmitter()

  dtTrigger: Subject<any> = new Subject()
  subscription: Subscription
  subscriptionSearch: Subscription
  form: FormGroup
  staffDataTableOptions: any = {}
  type
  initTableFirstTime = false
  listedContactHeader
  staffData
  listTable = []
  listHeader
  symbolValue
  asc = 1
  desc = -1
  dataExcelStaffContact = []

  constructor(
    private store: StoreService,
    private cpmService: CpmService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    const { symbol } = this.activatedRoute.snapshot.params

    if (symbol !== undefined) {
      this.symbolValue = symbol
    }

    if (symbol !== undefined) {
      this.getInformation(this.symbolValue)
    } else {
      this.subscription = this.store
        .getSecurityProfileNewResultObservable()
        .subscribe(response => {
          if (!response) {
            return
          }
          this.getInformation(response['securitySymbol'])
        })
    }

    this.listTable = []

    // tslint:disable-next-line:max-line-length
    this.listedContactHeader = [
      'Name Surname (TH)',
      'Name Surname (EN)',
      'Office number',
      'Mobile number',
      'Email',
      'Department'
    ]

    this.staffDataTableOptions = {
      autoWidth: false,
      searching: false,
      paging: false,
      info: false,
      language: {
        emptyTable: 'No information found'
      },
      destroy: true,
      dom: 'Bfrtip',
      buttons: ['excel'],
      drawCallback: () => {
        // $('.dataTables_filter').css({
        //   position: 'absolute',
        //   'margin-top': '-4%',
        //   'margin-left': '70%'
        // })
      }
    }
  }

  getInformation(symbol) {
    if (this.initTableFirstTime) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy()
      })
    }
    this.listTable = []

    if (symbol !== undefined) {
      this.cpmService.getAEList(symbol).then(
        success => {
          const listData = success
          listData.map(obj => {
            const list = {
              firstNameThai: obj.firstNameThai,
              lastNameThai: obj.lastNameThai,
              firstNameEng: obj.firstNameEng,
              lastNameEng: obj.lastNameEng,
              officeNumber: obj.officeNumber,
              mobileNumber: obj.mobileNumber,
              email: obj.email,
              department: obj.department
            }
            this.listTable.push(list)
          })

          if (!this.initTableFirstTime) {
            this.dtTrigger.next()
            this.initTableFirstTime = true
          } else {
            this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
              this.dtTrigger.next()
            })
          }
        },
        err => {
          console.log(err)
        }
      )
    }
  }

  sortList(list, key, sort) {
    list.sort((obj1, obj2) => {
      if (obj1[key] > obj2[key]) {
        return 1 * sort
      }
      if (obj1[key] < obj2[key]) {
        return -1 * sort
      }
      return 0
    })

    return list
  }

  moreThan10Char(word) {
    if (word.length <= 20) {
      return word
    } else if (word.length > 20) {
      return word.toStringLocal() + '...'
    }
  }
  ngOnDestroy() {
    this.subscription.unsubscribe()
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/staff-contact/staff-contact.component.ts